"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.evaluateFlags = exports.evaluateFlag = exports.FLAG_KEYS = exports.FeatureFlagKeys = exports.FeatureFlags = exports.FeatureFlagVariants = void 0;
const axios_1 = __importDefault(require("axios"));
const set_1 = __importDefault(require("lodash/set"));
var FeatureFlagVariants;
(function (FeatureFlagVariants) {
    FeatureFlagVariants["On"] = "on";
    FeatureFlagVariants["Off"] = "off";
})(FeatureFlagVariants = exports.FeatureFlagVariants || (exports.FeatureFlagVariants = {}));
exports.FeatureFlags = {
    creatorPortalLaunchpadForm: FeatureFlagVariants.Off,
    creatorHubWhitelist: FeatureFlagVariants.Off,
    ethDropCalendar: FeatureFlagVariants.Off,
    chSaveAsDraft: FeatureFlagVariants.Off,
    creatorHubBadgingApply: FeatureFlagVariants.Off,
    creatorHubBadgingTxnVolOverride: FeatureFlagVariants.Off,
    whitelistCreatorTwitter: FeatureFlagVariants.Off,
    whitelistCreatorNameInput: FeatureFlagVariants.Off,
    whitelistCreatorBlockchainSelector: FeatureFlagVariants.Off,
    syncToLMNFT: FeatureFlagVariants.Off,
    whitelistCreatorNftOwnedRequirement: FeatureFlagVariants.Off,
    createWhitelistDuringDropList: FeatureFlagVariants.Off,
    shouldCallUpsertCollectionsV1: FeatureFlagVariants.Off,
    shouldCallUpsertCollectionsV2: FeatureFlagVariants.Off,
    whitelistOpportunitiesSelfServe: FeatureFlagVariants.Off,
    creatorHubEnableRaffleSelfServe: FeatureFlagVariants.Off,
    creatorHubEnableRaffleV2Display: FeatureFlagVariants.Off,
    whitelistOpportunitiesSelfServeCreator: FeatureFlagVariants.Off,
    employeesOnly: FeatureFlagVariants.Off,
    enablePolygonCollectionCreatorHub: FeatureFlagVariants.Off,
    enableBitcoinCollectionCreatorHub: FeatureFlagVariants.Off,
    enableEthereumCollectionCreatorHub: FeatureFlagVariants.Off,
    // creator hub announcements self-serve feature
    CHASS: FeatureFlagVariants.Off,
    announcementStats: FeatureFlagVariants.Off,
    kmgo9fksziyvn7p8e: FeatureFlagVariants.Off,
    excludeBtcAnnouncements: FeatureFlagVariants.Off,
    enableAiAutoReject: FeatureFlagVariants.Off,
    enableAiAssessment: FeatureFlagVariants.Off,
    kk55ogwqt5k65i2yg: FeatureFlagVariants.Off, // https://flagr-admin.magiceden.io/#/flags/806 [CH] Creator Tips
};
exports.FeatureFlagKeys = Object.keys(exports.FeatureFlags).reduce((result, key) => (0, set_1.default)(result, key, key), {});
exports.FLAG_KEYS = Object.keys(exports.FeatureFlagKeys);
const FLAGR_URL = process.env.FLAGR_URL || 'https://flagr.magiceden.io/api/v1/evaluation';
const FLAGR_BATCH_URL = FLAGR_URL + '/batch';
function evaluateFlag({ key, entityContext, entityID, entityType, }) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield axios_1.default.post(FLAGR_URL, Object.assign(Object.assign({ entityID,
                entityType }, (entityContext && { entityContext })), { flagKey: key }));
            return (_a = response.data.variantKey) !== null && _a !== void 0 ? _a : null;
        }
        catch (_b) {
            return null;
        }
    });
}
exports.evaluateFlag = evaluateFlag;
function evaluateFlags(flagKeys, entity = {}) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const flags = flagKeys.reduce((result, flag) => (0, set_1.default)(result, flag, null), {});
        try {
            const { data } = yield axios_1.default.post(FLAGR_BATCH_URL, {
                flagKeys,
                entities: [entity],
            });
            for (const result of data.evaluationResults) {
                flags[result.flagKey] = (_a = result.variantKey) !== null && _a !== void 0 ? _a : null;
            }
        }
        finally {
            return flags;
        }
    });
}
exports.evaluateFlags = evaluateFlags;
